import { PropsWithChildren, useEffect, useRef } from "react"

import { twMerge } from "tailwind-merge"

import { flashClassName, FlashKind } from "./sharedClassNames"

export type FlashProps = {
  kind?: FlashKind
  rawHTML?: string
  className?: string
  scrollIntoView?: boolean
}

/**
 * Standard flash message component.
 */
export function Flash(props: PropsWithChildren<FlashProps>) {
  const { className, scrollIntoView = false, kind, rawHTML, children } = props

  const divRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scrollIntoView) {
      requestAnimationFrame(() => {
        divRef.current?.scrollIntoView()
      })
    }
  }, [])

  if (rawHTML) {
    return (
      <div
        ref={divRef}
        className={twMerge(flashClassName(kind), "block scroll-m-8", className)}
        dangerouslySetInnerHTML={{ __html: rawHTML }}
      />
    )
  } else {
    return (
      <div ref={divRef} className={twMerge(flashClassName(kind), "scroll-m-8", className)}>
        {children}
      </div>
    )
  }
}
